import IS_BROWSER from '@picsart/rc/isBrowser';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import type { UseObservable } from 'hooks/types';
import useInScreenViewStore from 'stores/inScreenViewStore';

const useObservableElement: UseObservable = (index = null) => {
  const observableComponents = useInScreenViewStore(x => x.observableComponents);
  const setObservableComponents = useInScreenViewStore(x => x.setObservableComponents);

  const { ref, inView } = useInView({
    rootMargin: '-100px 0px -200px 0px',
    threshold: 0,
    skip: !observableComponents[index] || !IS_BROWSER,
    fallbackInView: true,
    initialInView: !IS_BROWSER,
  });

  useEffect(() => {
    if (!index) return;

    setObservableComponents({ index, inView });
  }, [inView, index, setObservableComponents]);

  return ref;
};

export default useObservableElement;
